import type {
  IFullPageSection,
  IFullScreenBanner,
  IMultipleFeaturesWithDescAndPic,
} from './interface';

const path = '/img/products/live-encoder';

export const BANNER_DATA: IFullScreenBanner = {
  name: 'StreamLake直播编码器',
  title: '适用于IPTV、OTT、新媒体等场景',
  slogan: '帮助客户打造极致视听体验',
  backgroundImg: `${path}/banner.webp`,
  backgroundImgMobile: `${path}/banner-mobile.webp`,
  buttonText: '联系我们',
  description: [
    {
      title: '领先的编码质量',
      desc: '快手自研芯片驱动',
    },
    {
      title: '极致视听体验',
      desc: '质臻影音算法加持',
    },
    {
      title: '稳定可靠',
      desc: '多重保障手段护航',
    },
  ],
  businessLink: '/form/consult/live-encoder',
};

export const FEATURES: IMultipleFeaturesWithDescAndPic = {
  title: 'StreamLake直播编码器，帮助客户打造极致视听体验',
  items: [
    {
      title: '高质量编码',
      picUrl: `${path}/icon1.webp`,
    },
    {
      title: '4K/8K',
      picUrl: `${path}/icon2.webp`,
    },
    {
      title: '质臻增强',
      picUrl: `${path}/icon3.webp`,
    },
    {
      title: '质臻超分',
      picUrl: `${path}/icon4.webp`,
    },
    {
      title: '安全稳定',
      picUrl: `${path}/icon5.webp`,
    },
    {
      title: ' 监控报警',
      picUrl: `${path}/icon6.webp`,
    },
  ],
};

export const SECTION: IFullPageSection = {
  title: '内置快手自研视频处理芯片SL200',
  desc: '集成了快手领先的视频编码、图像处理、AI推理、内容自适应编码等关键技术，以行业领先的高质量实时编码，为行业客户赋能',
  picUrl: `${path}/section1.webp`,
  picUrlMobile: `${path}/section1-mobile.webp`,
};

export const COLLAPSIBLE_FEATURE_1: IMultipleFeaturesWithDescAndPic = {
  title: '极致的编码质量与性能',
  items: [
    {
      title: '极致的画质',
      subTitle:
        '自研SL200芯片带来了极致的压缩质量，相比x265 medium节省约30%码率',
      picUrl: `${path}/section2-pic1.webp`,
    },
    {
      title: '4K/8K超高清实时编码',
      subTitle:
        '支持4K/8K 10bit HDR超高清实时编码 ，带来身临其境的超高清视觉盛宴',
      picUrl: `${path}/section2-pic2.webp`,
    },
  ],
};

export const COLLAPSIBLE_FEATURE_2: IMultipleFeaturesWithDescAndPic = {
  title: '业界领先的AI画质增强算法',
  items: [
    {
      title: '质臻增强',
      subTitle: '突破编码能力上限，超越想象的画质重生算法，让视频更加清晰',
      picUrl: `${path}/section3-pic1.webp`,
    },
    {
      title: '质臻超分',
      subTitle:
        '支持将1080P分辨率实时超分为4K分辨率的视频，助力打造4K超高清频道',
      picUrl: `${path}/section3-pic2.webp`,
    },
  ],
};

export const TAB_FEATURE: IMultipleFeaturesWithDescAndPic = {
  title: '产品能力',
  items: [
    {
      title: '信号源输入',
      subTitle:
        '支持RTMP/HTTP/SDI等格式的信号源输入，支持信号源探测、信号源预览及备用信源',
      picUrl: `${path}/feature1.webp`,
    },
    {
      title: '视频处理',
      subTitle:
        '支持质臻影音算法以及丰富的转码参数配置，满足低码高清、画质增强等多种场景的视频处理需求',
      picUrl: `${path}/feature2.webp`,
    },
    {
      title: '一进多出',
      subTitle:
        '支持一路输入源转出不同分辨率的转码流，每路转码流支持输出多路流，满足多码率和多平台分发的需求',
      picUrl: `${path}/feature3.webp`,
    },
    {
      title: '系统监控',
      subTitle:
        '支持对转码任务状态、流数量、系统整体负载、各群组负载进行统计和监控',
      picUrl: `${path}/feature4.webp`,
    },
    {
      title: '集群管理',
      subTitle:
        '支持转码机器的1+1和m+n备份，支持任务智能调度及双调度机主备，保障集群运行稳定',
      picUrl: `${path}/feature5.webp`,
    },
    {
      title: '监控告警',
      subTitle:
        '提供任务监控大屏，支持信号源及转码流的画面预览监看、信号源探测、转码流和输出流曲线、性能相关指标监控以及链路监控',
      picUrl: `${path}/feature6.webp`,
    },
  ],
};
